import React, { useState, useEffect, useRef } from 'react';
import './room1.css';
import './room2.css';
import './room2task3.css';

import Settings from '../components/common/settings';
import Lost from '../components/common/lost';
import { useNavigate } from 'react-router-dom';

import lockedSound from '../audios/mixkit-click-error-1110.wav';
import settingsSound from '../audios/settoings.wav';
import codevid from '../assets/codevid.mp4';

const TOTAL_TIME = 10 * 60;
const ROOM_KEY = 'room2_time'; 

const Codevidlevel2 = () => {
  const navigate = useNavigate();

  const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);
  const [openSettings, setOpenSettings] = useState(false);
  const [showLosePopup, setShowLosePopup] = useState(false);

  const lockedAudio = useRef(null);
  const settingsAudio = useRef(null);

  useEffect(() => {
    lockedAudio.current = new Audio(lockedSound);
    settingsAudio.current = new Audio(settingsSound);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      const saved = localStorage.getItem(ROOM_KEY);

      if (!saved) return;

      const elapsed = Math.floor(
        (Date.now() - Number(saved)) / 1000
      );

      const remaining = Math.max(
        TOTAL_TIME - elapsed,
        0
      );

      setTimeLeft(remaining);

      if (remaining === 0) {
        setShowLosePopup(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const playSettingsSound = () => {
    if (!settingsAudio.current) return;

    settingsAudio.current.currentTime = 0;
    settingsAudio.current.play().catch(() => {});
  };

  const openSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(true);
  };

  const closeSettingsMenu = () => {
    playSettingsSound();
    setOpenSettings(false);
  };

  const minutes = String(
    Math.floor(timeLeft / 60)
  ).padStart(2, '0');

  const seconds = String(
    timeLeft % 60
  ).padStart(2, '0');

  const isWarning = timeLeft <= 60;
  const fillPercent = (timeLeft / TOTAL_TIME) * 100;

return (
  <section className="room2div22">
    <video
      className="codevidlevel2"
      autoPlay
      muted
      loop
      playsInline
    >
      <source src={codevid} type="video/mp4" />
    </video>

    <div className="page-content">
      <div className="room1nav">
        <div />

        <div className="roomtimer">
          <span className="timerlabel">
            TIME REMAINING
          </span>

          <div className="timerdiv">
            <span
              className={`timerdigits ${
                isWarning ? 'timerwarning' : ''
              }`}
            >
              {minutes}:{seconds}
            </span>
          </div>

          <div className="timerbar">
            <div
              className="timerbartill"
              style={{
                width: `${fillPercent}%`,
                background: isWarning
                  ? '#ff4444'
                  : '#D4AF37',
              }}
            />
          </div>
        </div>

        <div
          className="settings"
          onClick={openSettingsMenu}
        />
      </div>

      <button
        className="nextbtnn"
        onClick={() => navigate('/room2task4')}
      >
        NEXT
      </button>

      <Settings
        open={openSettings}
        onClose={closeSettingsMenu}
        onPlaySound={playSettingsSound}
        onNavigate={navigate}
      />

      <Lost
        open={showLosePopup}
        onRetry={() => {
          localStorage.removeItem(ROOM_KEY);
          window.location.reload();
        }}
      />
    </div>
  </section>
);
};

export default Codevidlevel2;